import { Styles } from 'react-modal'

export const modalStyles: Styles = {
  content: {
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    margin: 'auto',
    padding: 0,
    zIndex: 9999,
    background: 'none',
    border: 'none',
    inset: 0,
    display: 'flex',
    borderRadius: 0,
    position: 'static',
  },
  overlay: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    // overflowX: 'auto',
    // overflowY: 'auto',
  },
}
